import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { kickout } from "../../actions/identity";
import identitySelectors from "../../selectors/identity";
import { useSelector } from "react-redux";
import { Container, Loader } from "semantic-ui-react";
import queryString from "query-string";
import { useAnonymousToken } from "../../features/auth/hooks/useAnonymousToken";

export default function Kickout() {
  const dispatch = useDispatch();
  const { site } = useParams<{ site: string }>();
  const { redirect, isPublicOrigin } = queryString.parse(window.location.search) as {
    redirect?: string;
    isPublicOrigin?: string;
  };
  const anonymousLogout = useAnonymousToken((state) => state.logout);

  const isLoggedIn = useSelector(identitySelectors.isLoggedIn);
  const isCitizen = useSelector(identitySelectors.isCitizen);
  const publicKickout = isPublicOrigin === "true" || (!!isLoggedIn && !!isCitizen);

  useEffect(() => {
    if (publicKickout) anonymousLogout();
    dispatch(kickout(site, publicKickout, "Your session has expired. Please log in again.", redirect));
  }, [dispatch, site]);
  return (
    <Container>
      <Loader>Logging You Out</Loader>
    </Container>
  );
}
